import { CONFIG } from '../config.js';

export function resolveImageUrl(url) {
    if (!url) return url;

    // Check if it's already an absolute URL or inline SVG
    const isAbsolute = /^(https?:|data:|blob:|ftp:)/i.test(url) || url.trim().startsWith('<');

    if (isAbsolute) {
        return url;
    }

    const baseUrl = CONFIG.apiUrl || '';
    if (!baseUrl) {
        return url;
    }

    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

    return `${cleanBaseUrl}/${cleanUrl}`;
}

export function getQuestionLength(questions) {
    let length = 0;
    questions.forEach((question) => {
        let type = question.properties ? question.properties.type : question.type;
        if (type !== 'Engagement Trigger' && type !== 'Thank You Message') {
            length++;
        }
    });
    return length;
}

export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function shuffleArrayExceptFirstItem(array) {
    if (array.length <= 1) return array;
    const firstItem = array[0];
    const restOfArray = array.slice(1);
    const shuffledRest = shuffleArray(restOfArray);
    return [firstItem, ...shuffledRest];
}

export function shuffleArrayExceptLastItem(array) {
    if (array.length <= 1) return array;
    const lastItem = array[array.length - 1];
    const copyArr = array.slice(0, -1);
    const shuffledRest = shuffleArray(copyArr);
    shuffledRest.push(lastItem);
    return shuffledRest;
}

export function changeAnswerOptionsSequence(options, randomType) {
    let temp = [...options];
    let questionAnswers = [];
    switch (randomType) {
        case 'all_random':
            questionAnswers = shuffleArray(temp);
            break;
        case 'all_but_first_random':
            questionAnswers = shuffleArrayExceptFirstItem(temp);
            break;
        case 'all_but_last_random':
            questionAnswers = shuffleArrayExceptLastItem(temp);
            break;
        case 'no_random':
        default:
            questionAnswers = temp;
            break;
    }
    return questionAnswers.length > 0 ? questionAnswers : options;
}
